<script>
  import { User } from "sveltefire";
  import { slide } from "svelte/transition";
  import { push, link } from "svelte-spa-router";

  import Form from "../smart/Form.svelte";
  import EmailInput from "../dumb/EmailInput.svelte";
  import PasswordInput from "../dumb/PasswordInput.svelte";
  import GoogleSignInButton from "../dumb/GoogleSignInButton.svelte";
  import Button from "../dumb/Button.svelte";

  export let provider;

  export let hideInputs = false;

  const googleSignIn = (auth) => {
    hideInputs = true;
    auth.signInWithPopup(provider);
  };

  const emailSignIn = (auth) => {
    hideInputs = false;
    auth.signInWithEmailAndPassword(email, password);
  };

  let email;
  let password;
</script>

<div class="login">
  <User let:auth let:user>
    <div slot="default" class="login__container">
      <p>Signed in as {user.uid}</p>
      
      <button on:click={() => push('/organize')}>Organize</button>
      <button on:click={() => auth.signOut()}>Sign Out</button>
    </div>
    <div slot="signed-out" class="login__container">
      <Form>
        <img class="login__logo" src="images/scriber-logo.svg" alt="Scriber Logo" />
        <h2>Sign in</h2>
        {#if !hideInputs}
          <section transition:slide>
            <EmailInput bind:email />
            <PasswordInput bind:password />
          </section>
        {/if}
        <Button text="Sign in with Email" on:click={() => emailSignIn(auth)}/>
        <GoogleSignInButton on:click={() => googleSignIn(auth)} />
        <p class="message">Not registered? <a use:link href="/signup">Create an account</a></p>
      </Form>
    </div>
  </User>
</div>

<style>
  .login {
    background-color: var(--dark-brown);
    background-image: url('/images/libary-background.png');
    font-family: "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    font-family: "Work Sans", sans-serif;
  }

  .login__container {
    width: 33%;
    padding: 8% 0 0;
    margin: auto;
    display: block;
  }

  .login__logo {
    width: 50%;
    margin: auto;
    padding-bottom: 1.5em;
  }
</style>
